///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthReactiveInputBase } from './input-base';
import { GtthInputTypesEnum } from './input-types.enum';

export class GtthReactiveDropdown extends GtthReactiveInputBase<any> {
    controlType = GtthInputTypesEnum.DROPDOWN;
    options: any[] = [];
    valueKey: string;
    showKey: string;
    simpleArr: boolean;

    constructor(options: GtthReactiveDropdown) {
        super(options);
        this.options = options.options || [];
        this.valueKey = options.valueKey;
        this.showKey = options.showKey;
        this.simpleArr = !!options.simpleArr;
    }
}
